export const breakpoints = {
  mobile: 0,
  mobileLandscape: 641,
  tablet: 768,
  laptop: 1024,
  desktop: 1280,
};
